import { alpha, createTheme } from '@mui/material/styles';

/**
 * Основной фон приложения.
 * При смене обновите: комментарий у `body` в `src/index.css`, `theme-color` в `public/index.html`.
 */
export const APP_BACKGROUND = '#121212';

const FONT_FAMILY = [
  'Poppins',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(',');

export function createAppTheme() {
  const theme = createTheme({
    palette: {
      mode: 'dark',
      background: {
        default: APP_BACKGROUND,
      },
      text: {
        primary: '#ffffff',
        secondary: alpha('#ffffff', 0.7),
        disabled: alpha('#ffffff', 0.5),
      },
      divider: alpha('#ffffff', 0.12),
    },
    typography: {
      fontFamily: FONT_FAMILY,
      fontWeightBold: 700,
      fontWeightMedium: 500,
      fontWeightRegular: 400,
      fontWeightLight: 300,
    },
  });

  theme.typography.h1 = {
    ...theme.typography.h1,
    fontWeight: 'bold',
    fontSize: '4.25rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '3rem',
    },
  };

  theme.typography.h2 = {
    ...theme.typography.h2,
    fontWeight: 'bold',
    fontSize: '3rem',
  };

  theme.typography.h3 = {
    ...theme.typography.h3,
    fontWeight: 'bold',
  };

  theme.typography.h4 = {
    ...theme.typography.h4,
    fontWeight: 'bold',
  };

  theme.typography.h6 = {
    ...theme.typography.h6,
    fontSize: '1.5rem',
    lineHeight: '1.25',
    fontWeight: 'bold',
  };

  theme.typography.subtitle1 = {
    ...theme.typography.subtitle1,
    fontSize: '1.25rem',
    lineHeight: '1.2',
    fontWeight: 'bold',
  };

  theme.typography.body1 = {
    ...theme.typography.body1,
    fontSize: '1rem',
  };

  return theme;
}
